<template>
  <div class="c-contact">
    <button
      id="id-contact-button"
      type="button"
      class="w-12 md:w-14 h-12 md:h-14 rounded-full flex-center bg-primary text-xl text-white anim-float-attraction"
      aria-label="float contact button"
      data-ga4="landing_support_button"
      @click="request_open_goftino"
    >
      <span
        v-if="is_try_opening_goftino"
        class="absolute left-3 top-1/2 -translate-y-1/2 p-loading p-loading--center ml-4"
      />
      <nuxt-icon
        name="headphone"
        class="text-3xl"
        v-else
      />

      <span
        class="goftino_unread_count absolute left-0 top-0 bg-secondary rounded-full text-xs py-1 px-2 empty:hidden"
      />
    </button>
  </div>
</template>

<script setup>
import { watch, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import useGoftino from '~/assets/js/composables/other/useGoftino';
import { load_goftino } from '~/assets/js/plugins/goftino.js';

const route = useRoute();

const is_try_opening_goftino = ref(false);
const is_goftino_loaded = ref(false);
const is_muchat_loaded = ref(false);

const { is_loading_goftino, open_goftino } = useGoftino();

watch(is_loading_goftino, new_val => {
  if (is_try_opening_goftino.value && !new_val) {
    open_goftino();
    is_try_opening_goftino.value = false;
  }
});

const request_open_goftino = () => {
  if (is_loading_goftino.value) {
    is_try_opening_goftino.value = true;
    return;
  }

  open_goftino();
};

onMounted(() => {
  is_goftino_loaded.value = load_goftino();

  if (route.query.support === '1') {
    request_open_goftino();
  }
});
</script>

<style lang="scss">
.c-contact {
  $parent: #{&};

  display: flex;
  flex-direction: column;

  line-height: 18px;

  &--active {
    right: 64px;
    opacity: 1;
  }
}
</style>
